import {
  PersonaPrimaryAttributes,
  PersonaSecondaryAttributes,
} from "@/inference/engine/attributes/persona/types";

type UserTier = "Tier 1" | "Tier 2" | "Tier 3";

interface handleScore {
  handle: number;
}

function calculateUserTier(
  attributes: PersonaPrimaryAttributes & PersonaSecondaryAttributes,
): UserTier {
  // Assign points for GPU Tier
  const gpuScore = attributes.GPUTier;

  // Assign points for City Tier
  let cityScore = 0;
  switch (attributes.cityTier) {
    case "Tier 1":
      cityScore = 3;
      break;
    case "Tier 2":
      cityScore = 2;
      break;
    case "Tier 3":
      cityScore = 1;
      break;
  }

  // Normalize deviceModelRecency and deviceModelTier (1-5 scaled to 1-3)
  const normalizeScore = (value: number) => Math.ceil((value / 5) * 3);

  const deviceRecencyScore = normalizeScore(
    parseInt(attributes.deviceModelRecency),
  );
  const deviceTierScore = normalizeScore(parseInt(attributes.deviceModelTier));

  // Calculate total score
  const totalScore =
    gpuScore + cityScore + deviceRecencyScore + deviceTierScore;

  console.log("Total score:", totalScore);

  // Assign user tier based on total score
  if (totalScore >= 9) {
    return "Tier 1"; // Higher scores lead to Tier 1 (price descending)
  } else if (totalScore >= 5) {
    return "Tier 2"; // Moderate scores remain unchanged
  } else {
    return "Tier 3"; // Lower scores lead to Tier 3 (price ascending)
  }
}

export const fetchProducts = async (ids: string[]) => {
  const products = await Promise.all(
    ids?.map?.((id) => window.helium.datastore.getProduct({ id })) ?? [],
  );
  return products.map((p) => p?.details).filter(Boolean);
};

export const sortProduct = async ({
  productsIds,
}: {
  productsIds: string[];
}): Promise<string[]> => {
  const KEY = "priceRange";

  const attr = window.helium?.finalResponse?.persona?.attributes;
  if (!attr) return productsIds;

  const userTier = calculateUserTier(attr);

  console.log("User tier:", userTier);

  const res = await fetchProducts(productsIds);

  return res
    .sort((a, b) => {
      const valueA = a[KEY]?.minVariantPrice?.amount || 0;
      const valueB = b[KEY]?.minVariantPrice?.amount || 0;

      if (userTier === "Tier 1") {
        return valueB - valueA; // Descending order
      } else if (userTier === "Tier 3") {
        return valueA - valueB; // Ascending order
      }
    })
    .map((product) => product.id);
};

export function sortHandlesByQuantity(items: handleScore) {
  const sortedItems = Object.entries(items)
    .filter(([id, quantity]) => quantity > 0)
    .map(([id, quantity]) => ({ id, quantity }))
    .sort((a, b) => a.quantity - b.quantity);

  return sortedItems;
}
